import { Box, Typography } from '@mui/material';
import { IconButton } from '@sweep-io/sweep-design';
import { ArrowLeft } from '@sweep-io/sweep-design/dist/icons/ArrowLeft';
import { useWebhooksContext } from './WebhooksContext';
import { useFeatureToggle } from '../../../feature-flags/useFeatureToggle';

export const WebhooksHeader = () => {
  const { multiAccounts } = useFeatureToggle();
  const { setWebhooks, setEditWebhook } = useWebhooksContext();

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mr: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {!multiAccounts && (
            <IconButton
              size="tiny"
              variant="flat"
              onClick={() => {
                setWebhooks(false);
                setEditWebhook(undefined);
              }}
            >
              <ArrowLeft size="medium" />
            </IconButton>
          )}
          <Typography variant="h3">Add new integration</Typography>
        </Box>
      </Box>
    </>
  );
};
